// customFetchData.js - imports only what it needs
import axios from 'axios';
import withLoading from './withLoading';

export default url => dispatch =>
  withLoading(dispatch, async () => {
    try {
      const { data } = await axios.get(url);

      return data;
    } catch (err) {
      console.log(err);
    }
  });
